import React from 'react';

import FavoritesEditContext, {
  FavoritesEditContextValues
} from '@smart-tv/contexts/favorites-edit-context/favorites-edit-context';

export const useFavoritesEdit = (): FavoritesEditContextValues => {
  const values = React.useContext(FavoritesEditContext);

  return { ...values };
};

export default useFavoritesEdit;
